/* ==========================================================================
   Mundo Dos Filtros — cart-drawer.js
   Carrinho lateral usando a Cart AJAX API + Section Rendering API.
   ========================================================================== */

(function () {
  'use strict';

  var rotas = (window.tema && window.tema.rotas) || {};
  var config = (window.tema && window.tema.config) || {};

  function $(seletor, escopo) {
    return (escopo || document).querySelector(seletor);
  }

  function $$(seletor, escopo) {
    return Array.prototype.slice.call((escopo || document).querySelectorAll(seletor));
  }

  /* ------------------------------------------------- Renderizar seções -- */

  function buscarSecao(nome) {
    return fetch(rotas.carrinho + '?section_id=' + nome, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (resposta) {
      return resposta.text();
    });
  }

  function trocarConteudo(html, seletor) {
    var novo = new DOMParser().parseFromString(html, 'text/html').querySelector(seletor);
    var atual = $(seletor);
    if (novo && atual) atual.innerHTML = novo.innerHTML;
  }

  function atualizarContador(quantidade) {
    /* Bolinha vermelha sobre o ícone do carrinho: some quando está vazio. */
    $$('[data-carrinho-contador]').forEach(function (contador) {
      contador.textContent = quantidade > 99 ? '99+' : quantidade;
      contador.hidden = quantidade === 0;
    });

    /* Número no título "Seu carrinho (N)". Fica fora da área que é trocada na
       atualização, por isso é escrito aqui. Sempre visível, inclusive no zero.
       Nome próprio para não colidir com [data-carrinho-quantidade], que são os
       campos de quantidade de cada item. */
    $$('[data-carrinho-total-itens]').forEach(function (alvo) {
      alvo.textContent = '(' + quantidade + ')';
    });
  }

  function atualizarCarrinho(abrir) {
    return fetch(rotas.carrinho + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) {
        atualizarContador(carrinho.item_count);
        return buscarSecao('cart-drawer').then(function (html) {
          trocarConteudo(html, '[data-carrinho-drawer-conteudo]');
          if (abrir && config.carrinhoLateral && window.temaDrawer) {
            window.temaDrawer.abrir(document.getElementById('carrinho-drawer'));
          }

          /* Quem depende do conteúdo do carrinho escuta daqui em vez de
             consultar de novo: a página do produto usa isto para recalcular
             quantas unidades ainda cabem no seletor. */
          document.dispatchEvent(new CustomEvent('tema:carrinho', { detail: carrinho }));

          return carrinho;
        });
      });
  }

  window.temaCarrinho = { atualizar: atualizarCarrinho, atualizarContador: atualizarContador };

  /* ----------------------------------------------------- Alterar linha -- */

  function alterarLinha(linha, quantidade, elemento) {
    if (elemento) elemento.classList.add('carregando');

    return fetch(rotas.alterar + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: linha, quantity: quantidade })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return atualizarCarrinho(false);
      })
      .then(function () {
        /* A página do carrinho também precisa refletir a mudança. */
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        }
      })
      .catch(function () {
        if (elemento) elemento.classList.remove('carregando');
      });
  }

  /* ------------------------------------------------------- Observação -- */

  function salvarObservacao(texto) {
    return fetch(rotas.atualizar + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: texto })
    });
  }

  /* ---------------------------------------------------------- Eventos -- */

  function iniciar() {
    document.addEventListener('click', function (evento) {
      var remover = evento.target.closest('[data-carrinho-remover]');
      if (remover) {
        evento.preventDefault();
        alterarLinha(
          parseInt(remover.getAttribute('data-carrinho-remover'), 10),
          0,
          remover.closest('.carrinho-item')
        );
      }
    });

    document.addEventListener('change', function (evento) {
      var input = evento.target.closest('[data-carrinho-quantidade]');
      if (!input) return;

      var quantidade = parseInt(input.value, 10);
      if (isNaN(quantidade) || quantidade < 0) return;

      alterarLinha(
        parseInt(input.getAttribute('data-carrinho-quantidade'), 10),
        quantidade,
        input.closest('.carrinho-item')
      );
    });

    var tempoObservacao;
    document.addEventListener('input', function (evento) {
      var campo = evento.target.closest('[data-carrinho-observacao]');
      if (!campo) return;

      window.clearTimeout(tempoObservacao);
      tempoObservacao = window.setTimeout(function () {
        salvarObservacao(campo.value);
      }, 600);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
